import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

const edit = {
	PozadavekDruh: null as string | null,
	VyrobekndOzn: null as string | null,
	Text: null as string | null,
	PozadavekPfx: null as string | null,
	PozadavekNr: null as number | null,
	PozadavGenPrp: null as boolean | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
